/* eslint-disable @typescript-eslint/no-explicit-any */
export function isNaturalNumber(value: any): boolean {
  if (isNaN(value)) return false
  const x = parseFloat(value)
  return (x | 0) === x && x > 0
}
